import { Component } from '@angular/core'
import { SignupFlowService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-billing-for-wholesalers-section',
  templateUrl: './billing-for-wholesalers-section.component.html',
  styleUrls: ['./billing-for-wholesalers-section.component.scss'],
})
export class BillingForWholesalersSectionComponent {
  public getImageWebp =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/billing_note/section1/section_1_th-v2.webp'
      : 'https://flowaccountcdn.com/new_landing/image/functions/billing_note/section1/section_1_en-v2.webp'
  public getImage =
    this.translate.currentLang === 'th'
      ? 'https://flowaccountcdn.com/new_landing/image/functions/billing_note/section1/section_1_th-v2.png'
      : 'https://flowaccountcdn.com/new_landing/image/functions/billing_note/section1/section_1_en-v2.png'
  public getAltText = this.translate.currentLang === 'th' ? 'ทำใบวางบิล' : 'Invoice Generation'
  constructor(public translate: TranslateService, private signupFlowService: SignupFlowService) {}

  setCookiePreviousPath(): void {
    this.signupFlowService.setCookie('invoice', true)
  }
}
